// extracted by mini-css-extract-plugin
module.exports = {"container":"StickyFooter_container__3a_NA"};